import { Span } from 'alkali'
export function Logo() {
	let span = new Span()
	span.className = 'header-logo'
	span.innerHTML = `
	<svg class="logo" viewBox="0 0 24 24" stroke="#060" fill="none" stroke-linecap="round" stroke-linejoin="square">
	<line x1="14" y1="6" x2="7" y2="6" stroke-width="3"></line>
	<line x1="15.5" y1="6" x2="14" y2="6" stroke-width="3" stroke="rgba(0, 102, 0, 0.5)"></line>
	<line x1="11" y1="12" x2="7" y2="12" stroke-width="3"></line>
	<line x1="12" y1="12" x2="11" y2="12" stroke-width="3"  stroke="rgba(0, 102, 0, 0.5)"></line>
	<line x1="16" y1="18" x2="7" y2="18" stroke-width="3"></line>
	<line x1="17" y1="18" x2="16" y2="18" stroke-width="3"  stroke="rgba(0, 102, 0, 0.5"></line>
	<line x1="6" y1="3" x2="6" y2="21" stroke-width="1.9" stroke="black" stroke-linecap="square"></line>
	</svg>`
	return span
 }
 export function LogoWithHeader() {
 	let logo = new Logo()
	logo.innerHTML += `<span class="vidently">vidently</span>`
	logo.innerHTML += `<div class="tag-line">` +( Math.random() > 0.4 ? 'See evidence clearly.' : 'Evidence made clear.')+ `</div>`
	return logo
}